export default "__VITE_ASSET__DQ3FR9Sk__"